const ENGINE_ICON_MAP = {
  unknown: 'unknown',
  other: 'unknown',
  'mac-os-x': 'os-x-el-capitan',
  'os-x': 'os-x-el-capitan',
  'mac-os': 'os-x-el-capitan',

  'windows-8': 'windows-10',
  'windows-8-1': 'windows-10',
  'windows-10': 'windows-10',

  ubuntu: 'ubuntu',

  linux: 'unknown',
  debian: 'unknown',

  gnome: 'gnome',

  'windows-7': 'windows-xp-vista',
  windows: 'windows-xp-vista',
  'windows-xp': 'windows-xp-vista',
  'windows-vista': 'windows-xp-vista',

  chrome: 'chrome',
  chromium: 'chrome',
  'chrome-mobile-webview': 'chrome',

  safari: 'safari-for-mac',
  'mobile-safari-ui/wkwebview': 'safari-for-mac',

  firefox: 'firefox',

  opera: 'opera',
  'oprea-browser': 'opera',

  ie: 'ie',
  'internet-explorer': 'ie',

  edge: 'edge',

  baidu: 'baidu',
  'baidu-browser': 'baidu',
  baidu_bcp: 'baidu',
  baidu_web: 'baidu',

  qq: 'qq-browser',
  'qq-browser': 'qq-browser',
  qqbrowser: 'qq-browser',

  sogou: 'sogou',
  'sogou-browser': 'sogou',
  'sogou-explorer': 'sogou',

  maxthon: 'maxthon-for-pc',
  'maxthon-browser': 'maxthon-for-pc',

  liebao: 'unknown', // 没有图标
  'liebao-browser': 'unknown', // 没有图标

  uc: 'uc',
  'uc-browser': 'uc',

  ios: 'ios',
  mac: 'ios',

  android: 'android',

  'windows-phone': 'windows-10',
  'windows-moible': 'windows-10',

  blackberry: 'blackberry-os',
  'blackberry-os': 'blackberry-os',
  'blackberry-webkit': 'blackberry-os',

  'chrome-mobile': 'chrome',

  'safari-mobile': 'safari-for-mac',
  'mobile-safari': 'safari-for-mac',

  'firefox-mobile': 'firefox',

  'oprea-mobile': 'opera',
  'opera-mobile': 'opera',

  'ie-mobile': 'ie',

  'baidu-mobile': 'baidu',
  'baidu-browser-mobile': 'baidu',

  'qq-mobile': 'qq-browser',
  'qq-browser-mobile': 'qq-browser',

  'sogou-mobile': 'sogou',
  'sogou-browser-mobile': 'sogou',

  'maxthon-mobile': 'maxthon-for-mobile',
  'maxthon-browser-mobile': 'maxthon-for-mobile',

  dolphin: 'unknown', // to do
  'dolphin-browser': 'unknown',
  'dolphin-browser-mobile': 'unknown',

  'liebao-mobile': 'unknown', // to do
  'liebao-browser-mobile': 'unknown',

  'uc-mobile': 'uc',
  'uc-browser-mobile': 'uc',

  weixin: 'wechat',
  wechat: 'wechat',

  bing: 'bing',
  'bing-mobile': 'bing',
  'bing-browser': 'bing',
  'bing-browser-mobile': 'bing',

  google: 'google',
  '360search': '360search-circle',

  'chrome-mobile-ios': 'safari-for-mac',
  'android-sdk': 'android-sdk',

  //新报表
  mini_program: 'xiaochengxu1',
  sdk: 'sdk',
  weibo: 'weibo1',
  toutiao: 'toutiao_circle',
  toutiao_microapp: 'toutiao_circle',
  kuaishou: 'kuaishou',
  douyin: 'douyin',
  web: 'computer',
  sm: 'sm-circle',
  'sm-cn': 'sm-circle',
  'sm.cn': 'sm-circle',
  toutiaosearch: 'toutiao_circle',
  quickhand: 'kuaishou',
  redbook: 'xhs'
};

export default ENGINE_ICON_MAP;
